import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type WrapperContentProps = {
  configData: ConstraintConfigType;
};

/** Builder-only «Wrapper» accordion (FAM funds of funds, issue #63) — twin of Top Quality. */
export function WrapperContent({ configData }: WrapperContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="wrapper"
    />
  );
}
